export const MessageType = {
  JOINED_CHANNEL: 'joined-channel',
  INVALID_CHANNEL: 'invalid-channel',
  ICECANDIDATE: 'icecandidate' as 'icecandidate',
  OFFER: 'offer',
  ANSWER: 'answer' as 'answer',
  NEW_MEMBER: 'new-member',
  MODERATOR_NOT_ALLOWED: 'moderator-not-allowed',
  MODERATOR_NOT_AUTHENTICATED: 'moderator-not-authenticated',
  MEMBER_DISCONNECTED: 'member-disconnected',
  REMOVED_FROM_CHANNEL: 'removed-from-channel',
  REMOVE_FROM_CHANNEL: 'remove-from-channel',
  INVITE_SHARING: 'invite-sharing',
  STOP_SHARING: 'stop-sharing',
  CLIENT_STREAM_CLOSED: 'client-stream-closed',
  CLIENT_STREAM_PAUSED: 'client-stream-paused',
  DISPLAY_INTERRUPTED: 'display-interrupted',
  RESET_CHANNEL: 'reset-channel',
  CHANNEL_CLOSED: 'channel-closed',
  CONNECTION_REJECTED: 'connection-rejected',
  CONNECTION_REJECTED_OTHERS_JOIN: 'connection-rejected-others-join',
  CHANNEL_CONFIG: 'channel-config',
  // A display had to mute the video it plays (its browser blocked autoplay with sound).
  VOLUME_MUTED: 'volume-muted',
  // A sharer says whether its share carries audio. The server keeps the last one until the share stops.
  SHARER_AUDIO: 'sharer-audio',
  REQUEST_PIN: 'request-pin',
  INVALID_SECURITY_PIN: 'invalid-security-pin',
  REQUEST_AUTHENTICATION: 'request-authentication',
  RETURN_TO_STANDARD: 'return-to-standard',
  INVALID_AUTHENTICATION: 'invalid-authentication',
  INVALID_AUTHENTICATION_COMPANY: 'invalid-authentication-company',
  ERROR: 'error',
  DISPLAY_WEBRTC_RECOVERY: 'display-webrtc-recovery',
  // A display with stats logging turned on asks for our side of its connection with each of its own samples.
  SENDER_STATS_REQUEST: 'sender-stats-request',
  SENDER_STATS: 'sender-stats',
  // The server ends a session nobody shares to for too long: it removes a standard session's streamer, and ends a
  // moderated session for everyone. It warns the streamer (or the moderators) first, and takes the warning down once
  // they choose to stay or someone shares.
  SESSION_ACTIVITY: 'session-activity',
  IDLE_SESSION_WARNING: 'idle-session-warning',
  IDLE_SESSION_ACTIVE: 'idle-session-active',
  INPUT_CAPTURE_TOGGLE: 'input-capture-toggle',
} as const;

export type MessageType = (typeof MessageType)[keyof typeof MessageType];
